import { DEFAULT_ICON_PROPS, IIconProps } from './constants';

export const EmptyCheckboxIcon = ({ ariaLabel = 'radio on state', ...props }: IIconProps) => {
  const { size, width, height, title, ariaHidden, className } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      data-testid="EmptyCheckboxIcon"
      width={size ?? width}
      height={size ?? height}
      viewBox={`0 0 ${size ?? width} ${size ?? height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}
      <g clipPath="url(#clip0_2805_2423)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 1.67442C6.29734 1.67442 1.67442 6.29734 1.67442 12C1.67442 17.7027 6.29734 22.3256 12 22.3256C17.7027 22.3256 22.3256 17.7027 22.3256 12C22.3256 6.29734 17.7027 1.67442 12 1.67442ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
          fill="currentcolor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2805_2423">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
